import React from "react";
import ProfilePicture from "../../connectui/component/display/ProfilePicture";
import FlexContainer from "../../connectui/component/layout/FlexContainer";

const ProfilePictureExample = () => {
  return (
    <div>
      <h3>Profile Picture Example</h3>
      <FlexContainer gap="12px" wrap="wrap">
        <ProfilePicture name="Riley Larson" />
        <ProfilePicture name="Airbnb" />
      </FlexContainer>
    </div>
  );
};

export default ProfilePictureExample;
